import Head from "next/head";
import { make as TraitInfoPage } from "../../../../src/info/TraitInfoPage.bs";
import { traits as traitsT } from "common/src/bindings/Translation2.ts";
import { fromUrlName } from "common/src/tft-static/Sd.ts";

export default function TraitInfo({ traitId }) {
  return (
    <>
      <Head>
        <title>{`${traitsT(traitId)} Set 5.5 TFT Trait Info`}</title>
      </Head>
      <TraitInfoPage set={56} traitId={traitId} />
    </>
  );
}

export async function getStaticPaths() {
  return { paths: [], fallback: "blocking" };
}

export async function getStaticProps({ params }) {
  const { traitName } = params;
  const traitId = fromUrlName(traitName, 56);

  if (traitId == null) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      traitId,
    },
  };
}
